import { atom } from 'jotai';

import { appStateForModalsAtom } from '@/atoms/launchModalsConfigAtom';
import { SignupSource } from '@heidi/schema/ml-scribe';

/**
 * Stays app-side: it reads `appStateForModalsAtom`, an APP atom instance, and
 * an app atom is never imported into a package.
 */
export const isDictationPremiumTrialEligibleAtom = atom((get) => {
  const appState = get(appStateForModalsAtom);
  return (
    appState.isTauri &&
    appState.userSignupSource === SignupSource.dictate &&
    appState.isDictationEnabled
  );
});
